import React, { FC } from 'react'
import { Trans } from '@lingui/macro'
import Message, {
  MessageTypes
} from '../../../components/common/message/Message'

export const RelativeCampaignActionWarning: FC<{
  day: number | null
}> = ({ day }) => {
  if (day !== 0) {
    return null
  }
  return (
    <section>
      <Message type={MessageTypes.WARNING}>
        <Trans>
          When targeting the same day, actions are not guaranteed to be
          performed at the precise time chosen. If a user joins campaign at a
          later time of day, the action will be scheduled in the next 5 minutes
          after the user joined instead.
        </Trans>
      </Message>
    </section>
  )
}
